<template>
  <div
    class="list-first-element"
    v-if="firstElement"
  >
    <div
      class="list-first-element__index"
      tabindex="0"
      aria-label="Numer 1"
    >
      1
    </div>
    <div
      class="list-first-element__photo"
    >
      <div
        class="list-first-element__photo-content"
        :class="{photoContentWithoutPhoto: !firstElement.artists[0].photo}"
        v-bind:style="{ backgroundImage: 'url(' + firstElement.artists[0].photo + ')' }"
        v-if=" listNumber !== '11' || special"
      >
        <div
          class="list-first-element__photo-content-new"
          v-if="firstElement.isNew && listNumber !== '11'"
        >
          nowość
        </div>
      </div>
    </div>
    <div class="list-first-element__info">
      <div class="list-first-element__info-content">
        <div class="list-first-element__song-info">
          <p
            class="list-first-element__info-artist"
            @click="()=>{goToArtistSite(firstElement.artists[0].id)}"
            v-on:keyup.enter="()=>{goToArtistSite(firstElement.artists[0].id)}"
            tabindex="0"
            :aria-label="firstElement.artists[0].name"
          >
            {{ firstElement.artists[0].name }}
          </p>
          <p
            class="list-first-element__info-title"
            @click="()=>{goToSong(firstElement.id)}"
            v-on:keyup.enter="()=>{goToSong(firstElement.id)}"
            tabindex="0"
            :aria-label="firstElement.name"
          >
            {{ firstElement.name }}
          </p>
        </div>
        <div class="list-first-element__info-button">
          <i
            v-if="firstElement.mp3Path !== '' && firstElement.mp3Path === actualPlay && isPlaying"
            class="material-icons"
            @click="playMP3(firstElement.mp3Path)"
            v-on:keyup.enter="playMP3(firstElement.mp3Path)"
            tabindex="0"
            aria-label="Pauza"
          >
            pause_circle_outline
          </i>
          <i
            v-if="firstElement.mp3Path !== '' && firstElement.mp3Path === actualPlay && !isPlaying"
            class="material-icons"
            @click="playMP3(firstElement.mp3Path)"
            v-on:keyup.enter="playMP3(firstElement.mp3Path)"
            tabindex="0"
            aria-label="Odtórz"
          >
            play_circle_outline
          </i>
          <i
            v-if="firstElement.mp3Path !== '' && firstElement.mp3Path !== actualPlay"
            class="material-icons"
            @click="playMP3(firstElement.mp3Path)"
            v-on:keyup.enter="playMP3(firstElement.mp3Path)"
            tabindex="0"
            aria-label="Odtórz"
          >
            play_circle_outline
          </i>
            <ShareComponent 
            :id="firstElement.id"
            :name="firstElement.name"
            :first="true"/>
        </div>
      </div>
    </div>
    <div class="list-first-element__button">
      <div class="list-first-element__button-container">
        <div class="list-first-element__button-statistic" :class="{hidden: special}"
>
          <div
            class="list-first-element__statistic-box"
            tabindex="0"
            :aria-label="'zmiana'+firstElement.changeFromLastWeek"
          >
            <p>{{ firstElement.changeFromLastWeek }}</p>
            <div>zmiana</diV>
          </div>
          <div
            class="list-first-element__statistic-box"
            tabindex="0"
            :aria-label="firstElement.weeksOnList + 'raz na liście'"
          >
            <p>{{ firstElement.weeksOnList }}</p>
            <div v-if="top">{{top}}</diV>
          </div>
        </div>
        <div class="list-first-element__vote-button">
          <SelectButton
            buttonName="głosowanie"
            :action="()=>{addVote()}"
            v-if="!mainList"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectButton from '@/ui/SelectButton.vue';
import ShareComponent from '../../ShareComponent/ShareComponent'
import mixin from '../mixin';

export default {
  mixins: [mixin],
  components: {
    SelectButton,
    ShareComponent
  }
}
</script>

<style scoped lang="scss">
  .list-first-element {
    width: 100%;
    height: 15rem;
    background-color: #fefefe;
    margin: 1rem 0;
    display: flex;
    border-radius: 5px;
    &__index {
      height: 100%;
      width: 5rem;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
      background-color: #af2f82;
      background-image: linear-gradient(to top, #df2860, #5541bd);
      display: flex;
      justify-content: center;
      align-items: center;
      color: #c574e7;
      font-family: 'Poppins', sans-serif;
      font-size: 3.1875rem;
      font-weight: 700;
    }
    &__photo {
      margin: 0 1.25rem;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__photo-content {
      width: 18.75rem;
      height: 10.5rem;
      box-sizing: border-box;
      border: 1px solid #e13368;
      position: relative;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100%;
    }
    &__photo-content-new {
      position: absolute;
      width: 3rem;
      height: 1rem;
      bottom: -0.5rem;
      left: 7.875rem;
      background-color: #41ae17;
      color: #fff;
      font-family: 'Poppins', sans-serif;
      font-size: 0.55rem;
      text-transform: uppercase;
      font-weight: 400;
      display: flex;
      justify-content: center;
      align-items: center;
      &:before {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        left: -0.5rem;
        bottom: 0;
        border-top: 0.5rem solid #2e7114;
        border-left: 0.5rem solid transparent;
      }
      &:after {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        right: -0.5rem;
        bottom: 0;
        border-top: 0.5rem solid #2e7114;
        border-right: 0.5rem solid transparent;
      }
    }
    &__info {
      width: 25rem;
      height: 100%;
      display: flex;
      align-items: center;
    }
    &__info-content {
      height: 10.5rem;
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
    }
    &__info-artist {
      font-family: 'Poppins', sans-serif;
      color: #0f1626;
      font-size: 1.3rem;
      font-weight: 700;
      padding-bottom: 0.5rem;
      cursor: pointer;
    }
    &__info-title {
      font-family: 'Poppins', sans-serif;
      font-size: 1.2rem;
      color: #0f1626;
      cursor: pointer;
    }
    &__info-button {
      display: flex;
      align-items: center;
      i {
        color: #df2860;
        font-size: 2.5rem;
        cursor: pointer;
      }
    }
    &__info-button-social-media {
      width: 2rem;
      height: 2rem;
      background-image: url('/icons/media.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: 80%;
    }
    &__button {
      height: 100%;
      display: flex;
      align-items: center;
    }
    &__button-container {
      height: 10.5rem;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-items: center;
    }
    &__button-statistic {
      display: flex;
      &.hidden {
        display: none;
      }
    }
    &__statistic-box {
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: column;
      width: 9.5rem;
      height: 5.25rem;
      border-radius: 5px;
      background-color: #ebe6e6;
      margin-right: 1rem;
      p {
        color: #df2860;
        font-family: 'Poppins', sans-serif;
        font-size: 2rem;
        font-weight: 500;
      }
      div {
        color: #a491b8;
        font-family: 'Poppins', sans-serif;
        font-size: 0.7rem;
        text-transform: uppercase;
      }
    }
    &__vote-button {
      width: 10rem;
    }
    .photoContentWithoutPhoto {
      background-image: url('/img/zaslepa.jpg') !important;
    }
  }
</style>
